import { useQuery } from '@tanstack/react-query';
import { eventDashboardController } from './controller';
import { eventDashboardKeys } from './keys';

export const useSessionMetrics = (eventId: string, date?: string) => {
  return useQuery({
    queryFn: () => eventDashboardController.sessionMetrics({ urlParams: { eventId }, params: { date } }),
    queryKey: eventDashboardKeys.sessions(eventId, date),
    select: ({ data }) => data,
    refetchInterval: 60 * 1000,
  });
};

export const useSessionParticipants = (eventId: string, params?: { sessionId?: string }) => {
  return useQuery({
    queryFn: () => eventDashboardController.sessionParticipants({ urlParams: { eventId }, params }),
    queryKey: eventDashboardKeys.sessionParticipants(eventId, params),
    select: ({ data }) => data,
  });
};
